import { render, staticRenderFns } from "./PagSeguro.vue?vue&type=template&id=1734e03a&"
import script from "./PagSeguro.vue?vue&type=script&lang=js&"
export * from "./PagSeguro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports